import { render, staticRenderFns } from "./vipSwiper.vue?vue&type=template&id=2a1c5005&scoped=true&"
import script from "./vipSwiper.vue?vue&type=script&lang=js&"
export * from "./vipSwiper.vue?vue&type=script&lang=js&"
import style0 from "./vipSwiper.vue?vue&type=style&index=0&id=2a1c5005&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c5005",
  null
  
)

export default component.exports